/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Opportunityclosed2Inputs */

const en_coinvestments_share_opportunityclosed2 = /** @type {(inputs: Coinvestments_Share_Opportunityclosed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Coinvestments_Share_Opportunityclosed2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_opportunityclosed2 = /** @type {((inputs?: Coinvestments_Share_Opportunityclosed2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Opportunityclosed2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_opportunityclosed2(inputs)
});
export { coinvestments_share_opportunityclosed2 as "coInvestments_share_opportunityClosed" }